import { Injectable } from "@angular/core"

import { PageResultDto, BannerDto, FindBannerDto, CreateBannerDto } from "../dto"
import { HttpService } from "./http.service"


@Injectable()
export class BannerService {
  constructor(
    private httpService: HttpService
    ) {
  }

  async find({ placement }: FindBannerDto) {
    return await this.httpService.get<BannerDto[]>('/admin/banners', { placement })
  }

  async update(id: string, updateBannerOnboardDto: CreateBannerDto) {
    return await this.httpService.put<Boolean>(`/admin/banners/${id}`, updateBannerOnboardDto)
  }

  async create(createBannerOnboardDto: CreateBannerDto) {
    return await this.httpService.post<Boolean>(`/admin/banners`, createBannerOnboardDto)
  }

  async delete(id: string) {
    return await this.httpService.delete<Boolean>(`/admin/banners/${id}`)
  }

  async setEnabled(id: string, enabled: boolean) {
    if (enabled) {
      return await this.httpService.patch<Boolean>(`/admin/banners/${id}/enable`)
    }

    return await this.httpService.patch<Boolean>(`/admin/banners/${id}/disable`)
  }

  async sortOrder(bannerIds: string[]) {
    return await this.httpService.put<Boolean>(`/admin/banners/reorder`, { bannerIds })
  }
}